import React from "react";

export default class MsFeedbackMessage extends React.PureComponent {
  render() {
    let wrapperClass = 'message-wrapper ' + this.props.wclass;
    let eyebrowComponent = this.props.eyebrow ?
      (<p className="message-eyebrow">{this.props.eyebrow}</p>) : null;
    let subTitleComponent = this.props.subTitle ?
      (<p className="message-subtitle">{this.props.subTitle}</p>) : null;
    return (
      <div className="not-load-box">
        <div className={wrapperClass}>
          {eyebrowComponent}
          <h1 className="message-title">{this.props.title}</h1>
          {subTitleComponent}
          {this.props.message ?
            <p className="message-text">{this.props.message}</p>
            : null}
          {this.props.bottomComponent}
        </div>
      </div>
    );
  }
}
